import apiRequestService from '@/commonProject/service/apiRequestService';

export default class consultationWebRepository {
    /**
     * Web相談一覧API
     * @param {} request
     * @returns result
     */
    async postWebLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/weblst', requestBody, idToken);
        return result;
    }
    /**
     * Web相談取得API
     * @param {} request
     * @returns result
     */
    async getWebDtlActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/webdtl', queryParam, idToken);
        return result;
    }
    /**
     * Web相談メッセージ一覧API
     * @param {} request
     * @returns result
     */
    async postMsgLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/webmsglst', requestBody, idToken);
        return result;
    }
    /**
     * Web相談メッセージ既読登録API
     * @param {} request
     * @returns result
     */
    async postWebMsgRedActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/webmsgred', requestBody, idToken);
        return result;
    }
    /**
     * Web相談メッセージ登録API
     * @param {} request
     * @returns result
     */
    async postwebMsgDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/webmsgdtl', requestBody, idToken);
        return result;
    }
    /**
     * Web相談イシュー一覧API
     * @param {} request
     * @returns result
     */
    async postWebArmIsuActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/webarmisu', requestBody, idToken);
        return result;

    }
    /**
     * Web相談TMS相談分類取得API
     * @param {} request
     * @returns result
     */
    async postWebTmsCatActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/webtmscat', requestBody, idToken);
        return result;

    }
    /**
     * Web相談登録API
     * @param {} request
     * @returns result
     */
    async postConsultationWebActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/webdtl', requestBody, idToken);
        return result;
    }
}
